import { render, staticRenderFns } from "./VButton.vue?vue&type=template&id=87cfeaec"
import script from "./VButton.vue?vue&type=script&lang=js"
export * from "./VButton.vue?vue&type=script&lang=js"
import style0 from "./VButton.vue?vue&type=style&index=0&id=87cfeaec&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('87cfeaec')) {
      api.createRecord('87cfeaec', component.options)
    } else {
      api.reload('87cfeaec', component.options)
    }
    module.hot.accept("./VButton.vue?vue&type=template&id=87cfeaec", function () {
      api.rerender('87cfeaec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/controls/VButton.vue"
export default component.exports